var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ms-container full-width"},[_c('contract-editor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }